export default "__VITE_ASSET__4785fd64__"